import { type HTMLAttributes } from 'react';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';

export interface CheckboxProps extends HTMLAttributes<HTMLButtonElement> {
	id: string;
	intermediate?: boolean;
	label?: string;
}

const FoundationCheckbox = ({
	intermediate,
	label,
	id,
	...rest
}: CheckboxProps) => {
	return (
		<div className='wlcb-items-top wlcb-flex wlcb-items-center wlcb-space-x-2'>
			<Checkbox
				{...rest}
				intermediate={intermediate}
				id={id}
				className='peer checked:hover:wlcb-bg-current wlcb-transition-colors'
			/>
			{label ? (
				<Label
					htmlFor={id}
					style={{ color: 'var(--secondary-primary)' }}
					className='wlcb-text-caption wlcb-font-[400] peer-disabled:wlcb-cursor-not-allowed peer-disabled:wlcb-opacity-70'
				>
					{label}
				</Label>
			) : null}
		</div>
	);
};

export default FoundationCheckbox;
